import { flux } from '@/core/flux.module';
import { initializeReduxDevtools as initializeSharedReduxDevtools, registerReduxDevtoolsStore } from '@seeqdev/utils';

function registerFluxStoresForReduxDevtools() {
  for (const [storeName, store] of Object.entries(
    flux.dispatcher.storeInstances as Record<string, { state: unknown }>,
  )) {
    registerReduxDevtoolsStore(storeName, () => store);
  }
}

export const initializeReduxDevtools = () => {
  registerFluxStoresForReduxDevtools();
  initializeSharedReduxDevtools();
};
